<template>
  <b-container>
    <div v-if="isLoading" class="d-flex justify-content-center">
      <b-spinner label="Loading..." variant="dark" />
    </div>

    <b-row v-else class="justify-content-center">
      <b-col cols="12">
        <div class="display-4 font-weight-bold mb-4">User Dashboard</div>

        <b-tabs
          v-model="activeTab"
          lazy
          pills
          nav-class="nav-line nav-line-alt"
          content-class="pt-4"
        >
          <TabUserDashboard title="All" :dashboard="dashboardAll"></TabUserDashboard>

          <TabUserDashboard title="Verify" :dashboard="dashboardVerify"></TabUserDashboard>

          <TabUserDashboard
            title="Learn & Verify"
            :dashboard="dashboardLearnVerify"
          ></TabUserDashboard>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TabUserDashboard from './components/TabUserDashboard';
import Application from '@/models/Application';
import { userInfoMixin } from '@/mixins/userInfoMixin';
export default {
  components: {
    TabUserDashboard
  },
  mixins: [userInfoMixin],

  data() {
    return {
      isLoading: false,
      applicationIds: [],
      tabIndice: ['all', 'verify', 'learn-&-verify']
    };
  },

  computed: {
    currentTabName() {
      const { tab = 'all' } = this.$route.query;

      return tab;
    },

    activeTab: {
      set(index) {
        let { query } = this.$route;

        const tabName = this.tabIndice[index];

        if (query.tab != tabName) {
          this.$router.push({ query: { ...query, tab: tabName } });
        }
      },

      get() {
        const { currentTabName } = this;

        return this.getTabIndex(currentTabName);
      }
    },

    dashboardAll() {
      let applications = Application.findIn(this.applicationIds);

      return applications.map((application) => {
        const { status, evidenceSubmission } = application;

        return {
          ...application,
          status:
            status === 'DENIED' && evidenceSubmission.is_resubmitted ? 'NOT_SUBMITTED' : status
        };
      });
    },

    dashboardVerify() {
      return this.dashboardAll.filter((application) => application.mode === 'VERIFY');
    },

    dashboardLearnVerify() {
      return this.dashboardAll.filter((application) => application.mode === 'LEARN_VERIFY');
    }
  },

  mounted() {
    this.fetchDashboard();
  },

  methods: {
    async fetchDashboard() {
      this.applicationIds = [];

      try {
        this.isLoading = true;

        const promise = await Application.api().getDashboard();

        const { data = [] } = promise.response;

        this.applicationIds = data.map(({ id }) => id);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    getTabIndex(checkedTabName) {
      return this.tabIndice.findIndex((tabName) => tabName === checkedTabName);
    }
  }
};
</script>
